import { render, staticRenderFns } from "./ListingTBody.vue?vue&type=template&id=0df086a4&scoped=true&"
import script from "./ListingTBody.vue?vue&type=script&lang=ts&"
export * from "./ListingTBody.vue?vue&type=script&lang=ts&"
import style0 from "./ListingTBody.vue?vue&type=style&index=0&id=0df086a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df086a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VPagination,VRow,VSkeletonLoader})
